import { useCallback, useState } from "react";

const useListingGroupVisibility = (groups, getGroupKey) => {
  const [groupVisibility, setGroupVisibility] = useState({});

  const setAllGroupsVisibility = useCallback(
    (visible) => {
      const nextVisibility = {};
      groups.forEach((group) => {
        const key = getGroupKey(group);
        if (key) {
          nextVisibility[key] = visible;
        }
      });
      setGroupVisibility(nextVisibility);
    },
    [groups, getGroupKey]
  );

  const toggleGroupVisibility = useCallback((key) => {
    setGroupVisibility((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  }, []);

  return {
    groupVisibility,
    setGroupVisibility,
    setAllGroupsVisibility,
    toggleGroupVisibility,
  };
};

export default useListingGroupVisibility;
